<template>
  <button
    class="orange-button"
    v-on="$listeners"
  >
    <slot />
    <SpinnerLoader v-if="isLoading" class="ml-2" />
  </button>
</template>

<script>
import { SpinnerLoader } from '@/shared/ui/loader';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: { SpinnerLoader },
};
</script>

<style scoped>
.orange-button {
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #FB923C;
  background-color: #ffffff;
  border: 1px solid #FB923C;
  border-radius: 6px;
  padding: 12px 16px;
  cursor: pointer;
}
</style>
